import { Component, ViewChild, OnInit } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { VendorConfigModel } from './vendorconfig-model';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { FileToUpload } from '../../file-upload/file-to-upload.model';
import { ApiMethod } from '../../apimethods/api-method';

declare var $;


@Component({
  selector: 'app-config',
  templateUrl: './config.component.html'

})
/** config component*/
export class ConfigComponent implements OnInit {

  modelItem = new VendorConfigModel();

  @ViewChild('dataTable', { static: false }) table;

  dataTable: any;
  title: string;
  dataSet: any;
  showModal: boolean;

  public vendorList: any;
  public publisherList: any;
  public journalList: any;
  PublisherIDPop: any;
  JournalIDPop: any;
  theFile: any = null;
  messages: string[] = [];
  DFname: string = "";
  UFname: string = "";

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <VendorConfigModel>data["VendorConfigPage"];

        localStorage.aEID = 0;
        this.GetVendorConfigList();

        $('#ddlJournalID').select2({
          placeholder: "Select Journal",
          allowClear: true, tags: true
        });
        $('#ddlJournalID').val([]).trigger('change');

        this.GetVendorList();
        this.showUpload();
        this.showDownload();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }


  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return ngswal("Warning !", "Invalid Email ID!", "warning");
    }
    return true;

  }

  //Load Data List
  GetVendorConfigList(): void {
    $("#LoadingImage").show();

    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.VendorConfigListAPI + localStorage.aLoginID + '/' + npublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'VendorConfigurationModule';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.Message, "warning");
      });
  }



  //Get VendorList
  GetVendorList(): void {
    ApiMethod.getMethod(this.modelItem.VendorListAPI).subscribe(
      result => {
        this.vendorList = result.aVendorList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get list of Publisher by VendorID
  GetPublisherList(PublisherID = 0, VendorID = 0): void {

    let nvendorID = $('#ddlvendorID').val();
    if (nvendorID == null) {
      nvendorID = VendorID;
    }

    ApiMethod.getMethod(this.modelItem.PublisherListAPI + nvendorID).subscribe(
      result => {
        this.publisherList = result.aPublisherList;
        this.PublisherIDPop = PublisherID;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });


  }

  //Get list of Journals by publisherID

  GetJournalListByPublisherID(PublisherID = 0, JrnlList = null): void {

    let npublisherId = $('#ddlpublisherID').val();
    if (PublisherID != 0) {
      npublisherId = PublisherID;
    }

    ApiMethod.getMethod(this.modelItem.JournalListByPublisherIDAPI + npublisherId).subscribe(
      result => {
        this.journalList = result.aJournalList;
        this.JournalIDPop = JrnlList.toString();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }




  //Update VendorUploadDownloadConfig details method

  UpdateVendorConfig(): void {

    $("#LoadingImagePopup1").show();
    var VendorConfigDetails;
    var processType = " ";

    let FormID = $('#ddlProcessType option:selected').val();

    if ($('#ddlvendorID').val() == 0) {

      ngswal("Warning !", "Select Vendor!", "warning");
    }
    else if ($('#ddlpublisherID').val() == 0) {

      ngswal("Warning !", "Select Publisher!", "warning");

    }
    else if ($('#txtEMailID').val().trim() == '') {

      ngswal("Warning !", "Enter Email ID !", "warning");

    }
    else if ((FormID == "Download" && $('#ddlDownloadType').val().trim() == "0") ||
      (FormID == "Upload" && $('#ddlUploadType').val().trim() == "0")) {

      ngswal("Warning !", "Enter File Location!", "warning");

    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "S3") && $('#txtDBucketName').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "S3") && $('#txtUBucketName').val().trim() == '')) {

      ngswal("Warning !", "Enter Bucket Name!", "warning");

    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "S3") && $('#txtDAccessKey').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "S3") && $('#txtUAccessKey').val().trim() == '')) {

      ngswal("Warning !", "Enter Access Key!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "S3") && $('#txtDSecurityKey').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "S3") && $('#txtUSecurityKey').val().trim() == '')) {

      ngswal("Warning !", "Enter Security Key!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "FTP") && $('#txtDFHost').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "FTP") && $('#txtUFHost').val().trim() == '')) {

      ngswal("Warning !", "Enter Host Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "FTP") && $('#txtDFPort').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "FTP") && $('#txtUFPort').val().trim() == '')) {

      ngswal("Warning !", "Enter Port Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "FTP") && $('#txtDFUserName').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "FTP") && $('#txtUFUserName').val().trim() == '')) {

      ngswal("Warning !", "Enter User Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "FTP") && $('#txtDFPassword').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "FTP") && $('#txtUFPassword').val().trim() == '')) {

      ngswal("Warning !", "Enter Password!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "SFTP") && $('#txtDSFHost').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "SFTP") && $('#txtUSFHost').val().trim() == '')) {

      ngswal("Warning !", "Enter Host Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "SFTP") && $('#txtDSFPort').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "SFTP") && $('#txtUSFPort').val().trim() == '')) {

      ngswal("Warning !", "Enter Port Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "SFTP") && $('#txtDSFUserName').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "SFTP") && $('#txtUSFUserName').val().trim() == '')) {

      ngswal("Warning !", "Enter User Name!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "SFTP") && $('#txtDSFPassword').val().trim() == '') ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "SFTP") && $('#txtUSFPassword').val().trim() == '')) {

      ngswal("Warning !", "Enter Password!", "warning");
    }
    else if (((FormID == "Download" && $('#ddlDownloadType').val().trim() == "SFTP") && $('#DSFfile-input').val().trim() == '' && this.DFname == "") ||
      ((FormID == "Upload" && $('#ddlUploadType').val().trim() == "SFTP") && $('#USFfile-input').val().trim() == '' && this.UFname == "")) {

      ngswal("Warning !", "Select File!", "warning");
    }
    else {
      //FormID(Tab) = Download
      if (FormID == "Download") {

        processType = "Download";

        if ($('#ddlDownloadType').val() == "S3") {

          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlDownloadType').val(),
            ProcessType: processType,
            BucketName: $('#txtDBucketName').val(),
            BucketAccessKey: $('#txtDAccessKey').val(),
            BucketScertKey: $('#txtDSecurityKey').val(),
            Endpointregion: $('#txtDEndpointregion').val(),
            Remarks: $('#txtDRemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };

        }
        else if ($('#ddlDownloadType').val() == "FTP") {
          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlDownloadType').val(),
            ProcessType: processType,
            Host: $('#txtDFHost').val(),
            Port: $('#txtDFPort').val(),
            UserName: $('#txtDFUserName').val(),
            Password: $('#txtDFPassword').val(),
            Remarks: $('#txtDFRemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };

        }
        else if ($('#ddlDownloadType').val() == "SFTP") {

          var fileUpload = $("#DSFfile-input").get(0);
          var files = fileUpload.files;

          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlDownloadType').val(),
            ProcessType: processType,
            Host: $('#txtDSFHost').val(),
            Port: $('#txtDSFPort').val(),
            UserName: $('#txtDSFUserName').val(),
            Password: $('#txtDSFPassword').val(),
            KeyFile: ($("#DSFfile-input").val() == '' ? this.DFname : files[0].name),
            FolderPath: $('#txtDSFFolderPath').val(),
            Remarks: $('#txtDSFRemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };
        }
      }
      else if (FormID == "Upload")     //FormID(Tab) = Upload
      {
        processType = "Upload";
        if ($('#ddlUploadType').val() == "S3") {
          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlUploadType').val(),
            ProcessType: processType,
            BucketName: $('#txtUBucketName').val(),
            BucketAccessKey: $('#txtUAccessKey').val(),
            BucketScertKey: $('#txtUSecurityKey').val(),
            Endpointregion: $('#txtUEndpointregion').val(),
            Remarks: $('#txtURemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };
        }
        else if ($('#ddlUploadType').val() == "FTP") {
          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlUploadType').val(),
            ProcessType: processType,
            Host: $('#txtUFHost').val(),
            Port: $('#txtUFPort').val(),
            UserName: $('#txtUFUserName').val(),
            Password: $('#txtUFPassword').val(),
            Remarks: $('#txtUFRemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };

        }
        else if ($('#ddlUploadType').val() == "SFTP") {

          var fileUpload = $("#USFfile-input").get(0);
          var files = fileUpload.files;

          VendorConfigDetails = {
            ID: localStorage.aEID,
            VendorID: $('#ddlvendorID').val(),
            PublisherID: $('#ddlpublisherID').val(),
            JournalID: $('#ddlJournalID').val().toString(),
            NotifyEMailID: $('#txtEMailID').val(),
            NotifyCCEMailID: $('#txtCCEMailID').val(),
            NotifyBCCEMailID: $('#txtBCCEMailID').val(),
            EntryType: $('#ddlUploadType').val(),
            ProcessType: processType,
            Host: $('#txtUSFHost').val(),
            Port: $('#txtUSFPort').val(),
            UserName: $('#txtUSFUserName').val(),
            Password: $('#txtUSFPassword').val(),
            KeyFile: ($("#USFfile-input").val() == '' ? this.UFname : files[0].name),
            FolderPath: $('#txtUSFFolderPath').val(),
            Remarks: $('#txtUSFRemarks').val(),
            UpdatedBy: localStorage.aLoginID
          };
        }
      }

      ApiMethod.postMethod(this.modelItem.UpdateAPI, VendorConfigDetails).subscribe(
        response => {
          this.GetVendorConfigList();
          $("#LoadingImagePopup").hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response,
            showConfirmButton: false,
            timer: 1500
          });

          this.ClearAllData();
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopup1").hide();
        }
      );
    }
  }


  Delete() {
    ngswal({
      title: "Are you confirm to delete vendor config?",
      text: "vendor config deleted permenently !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Canceled !",
            text: "Cancel to delete vendor config",
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
  }

  DeleteConfirm() {
    $('#LoadingImage').show();

    ApiMethod.postMethod(this.modelItem.DeleteVendorConfigAPI + localStorage.aEID + '/' + localStorage.aLoginID, "").subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted !",
          text: result,
          showConfirmButton: false,
          timer: 1500
        });
        this.GetVendorConfigList();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }


  //Show Vendor Configuration popup
  show(): void {

    this.ClearAllData();
    $('#divmsg').hide();
    $('#divUfilename').hide();
    $('#divDfilename').hide();
    this.SetDownloadTabValues("Download", "S3");

    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();

      ApiMethod.getMethod(this.modelItem.VendorConfigByIdAPI + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.aitemList;

          //Common fields
          $('#ddlvendorID').val(itemL[0].VendorID).change();
          this.GetPublisherList(itemL[0].PublisherID, itemL[0].VendorID);
          $('#txtEMailID').val(itemL[0].NotifyEMailID);
          $('#txtCCEMailID').val(itemL[0].NotifyCCEMailID);
          $('#txtBCCEMailID').val(itemL[0].NotifyBCCEMailID);
          $('#ddlProcessType').attr("disabled", "disabled");


          if (itemL[0].ProcessType == "Download" && itemL[0].EntryType == "S3") {

            this.SetDownloadTabValues(itemL[0].ProcessType, itemL[0].EntryType);

            $('#txtDBucketName').val(itemL[0].BucketName);
            $('#txtDAccessKey').val(itemL[0].BucketAccessKey);
            $('#txtDSecurityKey').val(itemL[0].BucketScertKey);
            $('#txtDRemarks').val(itemL[0].Remarks);
            $('#txtDEndpointregion').val(itemL[0].Endpointregion);
          }
          else if (itemL[0].ProcessType == "Download" && itemL[0].EntryType == "FTP") {

            this.SetDownloadTabValues(itemL[0].ProcessType, itemL[0].EntryType);
            $('#txtDFHost').val(itemL[0].Host);
            $('#txtDFPort').val(itemL[0].Port);
            $('#txtDFUserName').val(itemL[0].UserName);
            $('#txtDFPassword').val(itemL[0].Password);
            $('#txtDFRemarks').val(itemL[0].Remarks);

          }
          else if (itemL[0].ProcessType == "Download" && itemL[0].EntryType == "SFTP") {

            this.SetDownloadTabValues(itemL[0].ProcessType, itemL[0].EntryType);
            $('#txtDSFHost').val(itemL[0].Host);
            $('#txtDSFPort').val(itemL[0].Port);
            $('#txtDSFUserName').val(itemL[0].UserName);
            $('#txtDSFPassword').val(itemL[0].Password);
            $('#txtDSFFolderPath').val(itemL[0].FolderPath);
            $('#txtDSFRemarks').val(itemL[0].Remarks);
            $('#divmsg').hide();
            this.DFname = itemL[0].KeyFile;
            $('#divDfilename').show();
          }
          else if (itemL[0].ProcessType == "Upload" && itemL[0].EntryType == "S3") {

            this.SetUploadTabValues(itemL[0].ProcessType, itemL[0].EntryType);


            $('#txtUBucketName').val(itemL[0].BucketName);
            $('#txtUAccessKey').val(itemL[0].BucketAccessKey);
            $('#txtUSecurityKey').val(itemL[0].BucketScertKey);
            $('#txtUEndpointregion').val(itemL[0].Endpointregion);
            $('#txtURemarks').val(itemL[0].Remarks);
          }
          else if (itemL[0].ProcessType == "Upload" && itemL[0].EntryType == "FTP") {

            this.SetUploadTabValues(itemL[0].ProcessType, itemL[0].EntryType);

            $('#txtUFHost').val(itemL[0].Host);
            $('#txtUFPort').val(itemL[0].Port);
            $('#txtUFUserName').val(itemL[0].UserName);
            $('#txtUFPassword').val(itemL[0].Password);
            $('#txtUFRemarks').val(itemL[0].Remarks);

          }
          else if (itemL[0].ProcessType == "Upload" && itemL[0].EntryType == "SFTP") {

            this.SetUploadTabValues(itemL[0].ProcessType, itemL[0].EntryType);
            $('#txtUSFHost').val(itemL[0].Host);
            $('#txtUSFPort').val(itemL[0].Port);
            $('#txtUSFUserName').val(itemL[0].UserName);
            $('#txtUSFPassword').val(itemL[0].Password);
            $('#txtUSFFolderPath').val(itemL[0].FolderPath);
            $('#txtUSFRemarks').val(itemL[0].Remarks);
            $('#divmsg').hide();
            this.UFname = itemL[0].KeyFile;
            $('#divUfilename').show();
          }

          try {
            let Journaldata = itemL[0].JournalID.split(',');
            let selectedJournalsValues = new Array();
            try {
              for (var i = 0; i < Journaldata.length; i++) {
                selectedJournalsValues[i] = Journaldata[i];
              }
            } catch (e) { }

            this.GetJournalListByPublisherID(itemL[0].PublisherID, selectedJournalsValues);

            $('#ddlJournalID').val(selectedJournalsValues).change();
          } catch (e) {
            $('#ddlJournalID').val('').change();
          }
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }

    this.showModal = true; // Show-Hide Modal Check
    this.title = "Vendor Config Details";    // Dynamic Data
    $('#myModal').css('height', (GlobalConstants.size.height - 10));
  }

  //Set Downloadload content
  SetDownloadTabValues(dptype, dentrytype) {
    $('#ddlProcessType').val(dptype).change();
    $('#ddlDownloadType').val(dentrytype).change();
    this.ShowTabByProcessType();
    this.showDownload();
  }

  //Set Upload content
  SetUploadTabValues(uptype, uentrytype) {
    $('#ddlProcessType').val(uptype).change();
    $('#ddlUploadType').val(uentrytype).change();
    this.ShowTabByProcessType();
    this.showUpload();

  }

  //Showing Content by processtype
  ShowTabByProcessType() {
    if ($('#ddlProcessType option:selected').val() == "Download") {
      $('#DownloadTab').show();
      $('#UploadTab').hide();
    }
    else if ($('#ddlProcessType option:selected').val() == "Upload") {
      $('#UploadTab').show();
      $('#UploadTab').removeClass("fade");
      $('#DownloadTab').hide();
    }
  }
  //Download
  ValidateFormByDownload(): void {
    this.showDownload();
  }

  //Upload
  ValidateFormByUpload(): void {
    this.showUpload();
  }

  //Logic for Hide and show of resp div. for Download tab
  showDownload(): void {

    //Download
    if ($('#ddlDownloadType').val() == "S3") {
      $('#DS3').show();
      $('#DSFTP').hide();
      $('#DFTP').hide();
    }
    else if ($('#ddlDownloadType').val() == "FTP") {
      $('#DFTP').show();
      $('#DS3').hide();
      $('#DSFTP').hide();
    }
    else if ($('#ddlDownloadType').val() == "SFTP") {

      $('#DSFTP').show();
      $('#DFTP').hide();
      $('#DS3').hide();
    }

  }

  //Logic for Hide and show of resp div for Upload tab
  showUpload(): void {

    //Upload
    if ($('#ddlUploadType').val() == "S3") {
      $('#US3').show();
      $('#USFTP').hide();
      $('#UFTP').hide();
    }
    else if ($('#ddlUploadType').val() == "FTP") {
      $('#UFTP').show();
      $('#US3').hide();
      $('#USFTP').hide();
    }
    else if ($('#ddlUploadType').val() == "SFTP") {
      $('#USFTP').show();
      $('#UFTP').hide();
      $('#US3').hide();
    }

  }



  //Method for Clear all fields from Form
  ClearAll(): void {

    this.PublisherIDPop = 0;
    this.JournalIDPop = "";
    $('#ddlProcessType').removeAttr("disabled", "disabled");
    this.messages = [];
    //Download

    $('#ddlvendorID').val(0).change();
    $('#ddlpublisherID').val(0).change();
    $('#ddlJournalID').val('').change();
    $('#txtEMailID').val('');
    $('#txtCCEMailID').val('');
    $('#txtBCCEMailID').val('');

    //S3
    $('#txtDBucketName').val('');
    $('#txtDAccessKey').val('');
    $('#txtDSecurityKey').val('');
    $('#txtDEndpointregion').val('');
    $('#txtDRemarks').val('');

    //FTP
    $('#txtDFHost').val('');
    $('#txtDFPort').val('');
    $('#txtDFUserName').val('');
    $('#txtDFPassword').val('');
    $('#txtDFRemarks').val('');

    //SFTP
    $('#txtDSFHost').val('');
    $('#txtDSFPort').val('');
    $('#txtDSFUserName').val('');
    $('#txtDSFPassword').val('');
    $('#DSFfile-input').val('');
    $('#txtDSFFolderPath').val('');
    $('#txtDSFRemarks').val('');
    this.DFname = "";             //Download tab KeyFile Name

    //Upload
    //S3
    $('#txtUBucketName').val('');
    $('#txtUAccessKey').val('');
    $('#txtUSecurityKey').val('');
    $('#txtUEndpointregion').val('');
    $('#txtURemarks').val('');

    //FTP
    $('#txtUFHost').val('');
    $('#txtUFPort').val('');
    $('#txtUFUserName').val('');
    $('#txtUFPassword').val('');
    $('#txtUFRemarks').val('');

    //SFTP
    $('#txtUSFHost').val('');
    $('#txtUSFPort').val('');
    $('#txtUSFUserName').val('');
    $('#txtUSFPassword').val('');
    $('#USFfile-input').val('');
    $('#txtUSFFolderPath').val('');
    $('#txtUSFRemarks').val('');
    this.UFname = "";         //Upload tab KeyFile Name
  }

  ClearAllData(): void {
    this.ClearAll();
    this.showModal = false;

  }

  //Bootstrap Modal Close event
  hide() {
    this.ClearAll();
    this.showModal = false;
  }


  //Key File Upload

  onFileChange(event) {
    this.theFile = null;
    if (event.target.files &&
      event.target.files.length > 0) {
      this.theFile = event.target.files[0];
    }
  }

  //Upload Keyfile for entrytpe SFTP
  uploadFile(): void {

    let FormID = $('#ddlProcessType option:selected').val();

    if ((FormID == "Download") && ($('#ddlDownloadType').val().trim() == "SFTP") && ($('#DSFfile-input').val().trim() == '')) {
      ngswal("Warning !", "Select File!", "warning");
    }
    else if ((FormID == "Upload") && ($('#ddlUploadType').val().trim() == "SFTP") && ($('#USFfile-input').val().trim() == '')) {
      ngswal("Warning !", "Select File!", "warning");
    }
    else {
      this.readAndUploadFile(this.theFile);
    }
  }


  private readAndUploadFile(theFile: any) {

    let tabName = $('#ddlProcessType option:selected').val();
    let fileLocation = "", filename = "";
    if (tabName == "Download") {
      fileLocation = $('#ddlDownloadType option:selected').val();

    }
    else if (tabName == "Upload") {
      fileLocation = $('#ddlUploadType option:selected').val();

    }

    let file = new FileToUpload();

    // Set File Information
    file.fileName = theFile.name;
    file.fileSize = theFile.size;
    file.vendorConfigID = localStorage.aEID;
    file.loginID = localStorage.aLoginID;
    file.publisherID = localStorage.aPubID;
    file.processType = tabName;
    file.entryType = fileLocation;
    // Use FileReader() object to get file to upload
    // NOTE: FileReader only works with newer browsers
    let reader = new FileReader();

    reader.onload = () => {
      file.fileAsBase64 = reader.result.toString();


      ApiMethod.postFileMethod(this.modelItem.UploadKeyFileAPI, file).subscribe(
        resp => {
          $('#divmsg').show();
          this.messages.push("Upload complete");

        });
    }

    // Read the file
    reader.readAsDataURL(theFile);

  }

  //Download KeyFile
  DownloadFile(): void {
    customfunctions.Downloadfile(ApiMethod.basePath + 'api/VendorConfig/GetFile/' + localStorage.aEID);
  }

}



